// extracted by mini-css-extract-plugin
export default {"table-root":"AstraTable_table-root__sjoBm","table-root__header":"AstraTable_table-root__header__01uKa"};